import { HqoDatePicker } from '@hqo/react-components-library';
import styled from 'styled-components';

export const StyledDatePicker = styled(HqoDatePicker)`
  .day-cell-inactive,
  .day-cell-adjacentMonth {
    text-decoration-line: line-through;
  }
`;
